// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PageOutlinedSvg from "@fishx/icons-svg/es/asn/PageOutlined";
import FishxIcon from '../components/FishxIcon';

var PageOutlined = function PageOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PageOutlinedSvg
  }));
};

PageOutlined.displayName = 'PageOutlined';
export default React.forwardRef(PageOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PageOutlined.js
// module id = 3743
// module chunks = 0